import type { OrderItem, SelectedItemInfo } from '@/types';

/**
 * 운반 도움이 반드시 필요한 물품인지 판정한다.
 *
 * 새 케이스를 추가하려면 이 함수에 규칙을 추가하세요.
 * - `category` 필드는 물품명(예: '옷장')과 동일 (Step1ItemInfo에서 그렇게 저장됨)
 * - `options.plusValue`, `options.extraValue` 등으로 옵션 조건을 검사
 */
export function itemRequiresCarryHelp(
  item: { category?: string | null; displayName?: string; options?: Record<string, unknown> },
): boolean {
  const name = item.displayName || item.category || '';
  const options = item.options || {};

  // 옷장: 항상 운반 도움 필요
  if (name === '옷장') return true;

  // 매트리스: 퀸 사이즈
  if (name === '매트리스' && options.plusValue === '퀸') return true;

  // 책상, 식탁, 테이블: 세라믹 또는 대리석 옵션 선택 시
  if (name === '책상, 식탁, 테이블') {
    const extras = options.extraValue;
    if (Array.isArray(extras) && extras.includes('세라믹 또는 대리석')) return true;
  }

  return false;
}

/**
 * 주문(확정 items + 현재 편집 중인 itemInfo) 전체에서 운반 도움이 필요한지 판정.
 */
export function orderRequiresCarryHelp(
  items: OrderItem[],
  itemInfo: SelectedItemInfo,
): boolean {
  for (const item of items) {
    if (itemRequiresCarryHelp(item)) return true;
  }
  if (itemInfo.itemId && itemRequiresCarryHelp({ category: itemInfo.category, options: itemInfo.options })) {
    return true;
  }
  return false;
}
